import Handler from '@/core/domain/usecase/handler';

const fetchReleaseRepository = (axios) => async (pagination) => {
    try {
        const response = await axios.get('/release', {
            params: pagination
        })
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchReleaseRepository